import React from "react";
 import { Link } from 'react-router-dom';
 import SettingsDropdown from './SettingsDropdown';
 import { useTranslation } from 'react-i18next';
 import logo  from './../assets/images/favicon-32x32.png'
import { Container, Nav, Navbar } from "react-bootstrap";
import useIsMobile from "./../hooks/mobile";
import Logo from "./shared/Logo";



 const Header: React.FC = () => {
const { t } = useTranslation();
const isMobile = useIsMobile(); // use the hook from before

return (
  <Navbar bg="light" expand="lg" className="mb-3">
    <Container>   
      <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
        <img
                  src={ logo }
                  height="32"
                  className="d-inline-block align-top"
                  alt="Logo aplikacije"
        />
        {/* {t('appName') } */}
        <Logo></Logo>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="navbar-content" />
      <Navbar.Collapse id="navbar-content" className="justify-content-between">
        <Nav className="align-items-start">
            <Nav.Link as={Link} to="/invoices">{t('invoices')}</Nav.Link>
            <Nav.Link as={Link} to="/offers">{t('offers')}</Nav.Link>
            <Nav.Link as={Link} to="/invoice-book">{t('invoiceBook')}</Nav.Link>
            <Nav.Link as={Link} to="/info">{t('info')}</Nav.Link>

        </Nav>
        <Nav className={!isMobile? "align-items-end" : "align-items-start" }>           
          <SettingsDropdown />
        </Nav>
      </Navbar.Collapse>
    </Container>
  </Navbar>
);

}
export default Header;
